import React from 'react';
import { StyledDescription, StyledTitle, StyledWrapper } from './styled';

export interface InfoMessageProps {
  title?: string;
  description: string;
}

export const InfoMessage: React.FC<InfoMessageProps> = ({
  title,
  description,
}) => (
  <StyledWrapper>
    <StyledTitle>{title || 'Info'}</StyledTitle>
    <StyledDescription>{description}</StyledDescription>
  </StyledWrapper>
);
